import { Leaf } from 'lucide-react';

const LEAVES = [
  { left: '5%', delay: '0s', duration: '11s', size: 22, color: 'text-lime-500' },
  { left: '15%', delay: '4s', duration: '14s', size: 16, color: 'text-green-600' },
  { left: '28%', delay: '2s', duration: '12s', size: 20, color: 'text-lime-400' },
  { left: '42%', delay: '7s', duration: '15s', size: 14, color: 'text-green-700' },
  { left: '55%', delay: '1s', duration: '13s', size: 24, color: 'text-green-500' },
  { left: '68%', delay: '5s', duration: '11s', size: 18, color: 'text-green-700' },
  { left: '80%', delay: '3s', duration: '16s', size: 20, color: 'text-lime-500' },
  { left: '92%', delay: '8s', duration: '12s', size: 15, color: 'text-lime-400' },
];

export const FallingLeaves = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="hero-falling-leaves">
    {LEAVES.map((l) => (
      <Leaf
        key={l.left}
        className={`falling-leaf ${l.color} fill-current opacity-70`}
        style={{ left: l.left, width: l.size, height: l.size, animationDelay: l.delay, animationDuration: l.duration }}
      />
    ))}
  </div>
);
